import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    ButtonGroup,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { documentsActionsSaga } from '../../../../infrastructure/services/documents'
import { documentsActions } from '../../../../application/actions/documents';
import { Box } from '@mui/material';
import Alert from '@mui/material/Alert';
import * as docx from "docx-preview";


const ShowDocuments = ({
    handlerShow,
    trackingCase,
    show,
    title
}) => {

    const dispatch = useDispatch();
    const { getById } = useSelector((store) => store.tk.documents);
    const { buffer, result, error, message } = useSelector((store) => store.tk.documents.getByIdDonwload);
    const { data: getAllClient } = useSelector((store) => store.tk.client.getAll);

    const handlreGetComents = () => {
        const id =  getAllClient.filter(item => item.nameComapny === trackingCase.nameCliente)[0]?.id
        id && dispatch(documentsActionsSaga.getById({ id }));
    };

    useEffect(() => {
        handlreGetComents();
    }, [trackingCase]);

    const findDocument = (document) => {
        const { clientId, name } = document
        dispatch(documentsActions.getByIdDonwloadReset())
        dispatch(documentsActionsSaga.getByIdDonwload({ clientId, name, caseId: trackingCase.idcase }));
    }

    const showDocument = () => {
        buffer !== '' && docx
            .renderAsync(buffer, document.getElementById('containerDocx'))
        //.then((x) => console.log("docx: finished"));
    }

    useEffect(() => {
        result && showDocument()
    }, [result]);

    const handlerExit = () => {
        dispatch(documentsActions.getByIdDonwloadReset())
        handlerShow()
    }

    const stackMessage = () => {
        const starckMessage = !error ? (<Stack sx={{ pl: 1, pr: 1 }} spacing={2}>
            <Alert severity="info">Selecciona una formato para visualizarlo</Alert>
        </Stack>):(<Stack sx={{ pl: 1, pr: 1 }} spacing={2}>
            <Alert severity="error">Formato no disponible</Alert>
        </Stack>)
        return starckMessage
    }

    const handlerDownload = () => {
        const blob = new Blob([buffer]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'prueb.docx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    return (
        <Dialog
            disableEscapeKeyDown
            open={show}
            onClose={() => handlerExit()}
            fullWidth={'lg'}
            maxWidth={'lg'}
        >
            <DialogTitle sx={{ lineHeight: 1.2 }}>
                <Typography sx={{ pb: 0, mb: 1 }} variant="h5" component="p">{title}</Typography>
                <Stack direction="row" spacing={1}>
                    {getById.data.map(option => (
                        <Chip label={option.name} onClick={() => findDocument(option)} />
                    ))}
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ p:0 }}>
                {!error && <Box id='containerDocx' />}
                {!result && stackMessage()}
            </DialogContent>
            <DialogActions>
                <ButtonGroup sx={{ pt: 0 }} fullWidth variant="contained" >
                    <Button disabled={!result} onClick={() => { handlerDownload(); }}>
                        Descargar
                    </Button>
                    <Button onClick={() => { handlerExit(); }}>
                        Salir
                    </Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>
    );
}

export default ShowDocuments;